export const CHALLENGE_INITIAL_TIMER_DURATION = 7 * 60;
